import FeedSettingsIcon from './feed-settings-icon';
export default FeedSettingsIcon;
